import { RegisterPage } from '@agentic-flow-studio/shared/components/auth/RegisterPage';
import { InboxClinicLogo } from '@agentic-flow-studio/shared/components/inbox-clinic-logo';
import { authClient } from '@/utils/betterAuth';

export default function Register() {
  return (
    <RegisterPage
      brandName="Inbox Clinic"
      logo={<InboxClinicLogo className="h-7 w-7" />}
      app="clinic"
      authClient={authClient}
    />
  );
}
